import React, { useState } from "react";
import { Row, Button, Spinner, Form } from "react-bootstrap";
import styles from "../AsnPage.module.css";
import "moment/locale/id";
import checkStatusLogo from "../../../icons/check-status.svg";
import * as apiPurchaseOrder from "../../../apis/purchaseOrder";
import { toast } from "react-toastify";

const TITLE = "Masukan ID Purchase Order (PO)";
const INPUT_REQUIRED = "* Wajib diisi";
const PO_NOT_VALID = "ⓘ ID Purchase Order (PO) tidak valid";
const SUPPLIER_CODE_DIFFERENT =
  "ⓘ Kode supplier tidak sesuai dengan ID Purchase Order (PO)";
const PO_HAS_INBOUND = "ⓘ Inbound sudah dilakukan. ASN tidak dapat di-submit";
const PO_STATUS = {
  CLOSED: "CLOSED",
  PENDING: "PENDING",
  CANCELLED: "CANCELLED",
  APPROVED: "APPROVED",
};

const SearchPurchaseOrder = ({
  isLoading,
  setIsLoading,
  setPurchaseOrder,
  displayAlert,
}) => {
  const [poIdController, setPoIdController] = useState("");
  const [supplierCode, setSupplierCode] = useState("");
  const [poErrorMessage, setPoErrorMessage] = useState("");
  const [supplierCodeErrorMessage, setSupplierCodeErrorMessage] = useState("");

  const onChangePoId = (e) => {
    setPoErrorMessage(null);
    setPoIdController(e.target.value);
  };

  const onChangeSupplierCode = (e) => {
    setSupplierCodeErrorMessage(null);
    setSupplierCode(e.target.value);
  };

  const onSubmitSearch = async (e) => {
    e.preventDefault();
    if (poIdController === "" || supplierCode === "") {
      if (poIdController === "") setPoErrorMessage(INPUT_REQUIRED);
      if (supplierCode === "") setSupplierCodeErrorMessage(INPUT_REQUIRED);
      setPurchaseOrder(null);
      return;
    }

    try {
      setIsLoading(true);
      const { data } = await apiPurchaseOrder.getPurchaseOrderById(
        poIdController
      );

      const purchaseOrder = data.data;
      if (!purchaseOrder) {
        setPurchaseOrder(null);
        return setPoErrorMessage(PO_NOT_VALID);
      }

      if (
        purchaseOrder?.supplier?.supplierCode?.toUpperCase() !=
        supplierCode.toUpperCase()
      ) {
        setPurchaseOrder(null);
        return setSupplierCodeErrorMessage(SUPPLIER_CODE_DIFFERENT);
      }

      if (!!purchaseOrder?.hasInbound && !purchaseOrder.asn) {
        setPurchaseOrder(null);
        return setPoErrorMessage(PO_HAS_INBOUND);
      }

      if (!(PO_STATUS.APPROVED == purchaseOrder.status) && !purchaseOrder.asn) {
        setPurchaseOrder(null);
        return setPoErrorMessage(PO_NOT_VALID);
      }

      setPurchaseOrder(purchaseOrder);
      toast.success("ID Purchase Order (PO) berhasil Ditemukan", {
        autoClose: 2000,
      });
    } catch (e) {
      if (e.message == "Purchase Order not found") {
        setPurchaseOrder(null);
        return setPoErrorMessage(PO_NOT_VALID);
      }
      displayAlert({ type: "error" });
      setPurchaseOrder(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className={styles.iconArea}>
        <img src={checkStatusLogo} className={styles.iconImage} />
      </div>
      <Row className="mt-4 justify-content-center">
        <h5 className="text-center mb-3">{TITLE}</h5>
        <div className="w-50">
          <Form>
            <InputForm
              onChange={onChangePoId}
              type={"number"}
              placeHolder={"Masukan ID Purchase Order, Contoh : 1122"}
              error={poErrorMessage}
            />
            <InputForm
              onChange={onChangeSupplierCode}
              type={"text"}
              placeHolder={"Masukan Kode Supplier"}
              error={supplierCodeErrorMessage}
              maxLength={4}
            />
            <div className="d-flex justify-content-center">
              <Button
                type="submit"
                className={styles.btnGreen}
                disabled={isLoading}
                onClick={onSubmitSearch}
              >
                {isLoading && <Spinner animation="border" size="sm" />}
                Cari
              </Button>
            </div>
          </Form>
        </div>
      </Row>
    </div>
  );
};

const InputForm = ({ onChange, error, placeHolder, type, maxLength = null}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Control
        onChange={onChange}
        type={type}
        className={!!error ? "is-invalid" : ""}
        placeholder={placeHolder}
        maxLength={maxLength}
      />
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </Form.Group>
  );
};

export default SearchPurchaseOrder;
